/* Api methods to call /functions */
import { Fabric } from 'jsc8';
import { Credentials } from '../Config.js'

let fabric = "";
async function login() {
  fabric = new Fabric(Credentials.url)
  try {
    await fabric.login(Credentials.email, Credentials.password);
  }
  catch (e) {
    console.log("Auth failed")
    console.log(e)
  }

}
async function collection() {
  const collection = fabric.collection('list');
  const result = await collection.exists();
  if (result === true) {
    console.log("Collection list exists")
  }
  else {
    console.log("Creating collection")
    await collection.create();
  }

}
async function saveQueries() {
  let query = `INSERT {data:{title:@title, completed:@completed}} INTO list`
  await fabric.saveQuery("Write", {}, query)
  query = `FOR doc in list RETURN doc`
  await fabric.saveQuery("ReadAll", {}, query)
  query = `REMOVE @_key IN list`
  await fabric.saveQuery("Remove", {}, query)
  query = `UPDATE @key with {"completed":@state} in list`
}

async function init() {

  await login();
  await collection();
  await saveQueries();
}



const create = async (data) => {
  data = JSON.stringify(data)
  let query = `INSERT {data:${data}} INTO list`
  await fabric.query(query)
  //let resp = fabric.executeSavedQuery("Write", {title:data.title, completed:data.completed})

}

const readAll = async () => {
  try {
    let resp = await fabric.executeSavedQuery("ReadAll")
    return resp.result
  }
  catch (e) {
    console.log(e)
  }

}

const update = async (todoId, data) => {
  let query = `UPDATE @key with {"data":{"completed":@state, "title":@title}} in list`
  //let resp = fabric.executeSavedQuery("Update", {_key:todoId, state:data.completed})
  let resp = await fabric.query(query, { key: todoId, state: data.completed, title: data.title })
  return resp
}

const deleteTodo = async (todoId) => {
  let resp = await fabric.executeSavedQuery("Remove", { _key: todoId })
  return resp

}

const batchDeleteTodo = async (todoIds) => {
  console.log(todoIds)
  for (let todoId of todoIds) {
    await fabric.executeSavedQuery("Remove", { _key: todoId })
  }
}

export default {
  init: init,
  create: create,
  readAll: readAll,
  update: update,
  delete: deleteTodo,
  batchDelete: batchDeleteTodo
}
